export { default } from './LoansTableContentBase'
